import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import DefaultCover from 'assets/images/digital/default-cover.jpg'
import styles from './styles.scss'

const coverImageUrl = ({ options }, images) => {
  if (options && options.cover_image_id){
    const image = images[options.cover_image_id]
    if (image && image.large_url){
      return image.large_url
    }
  }

  return DefaultCover
}

class Header extends Component {
  _renderLogo = () => {
    const { brand } = this.props

    if (brand.logo){
      const logoUrl = brand.logo.small
      return <div className={styles.logo} style={{ backgroundImage: `url(${logoUrl})` }} />
    }

    return null
  }

  _renederCustomGradient = () => {
    const { brand } = this.props
    const { colour_gradient_start, colour_gradient_end } = brand

    const isCustomGradient = colour_gradient_start && colour_gradient_end
    const gradientCustomStyle = isCustomGradient
      ? {
        backgroundImage: `linear-gradient(to bottom right, #${colour_gradient_start}, #${colour_gradient_end})`,
      }
      : null
    const gradientClass = isCustomGradient ? classnames(styles.gradient, styles.custom) : styles.gradient

    return (
      <span>
        {gradientCustomStyle && (
          <div className={classnames(styles.gradient, styles.customGradient)} style={gradientCustomStyle} />
        )}
        <div className={gradientClass} />
      </span>
    )
  }

  _renderAgents = () => {
    const { agents, campaign } = this.props

    if (campaign.agents){
      return campaign.agents.map((agentId) => {
        const agent = agents[agentId] || {}
        return (
          <span
            key={agent.id}
            className={styles.agent}
            style={{ backgroundImage: agent.default_image ? `url(${agent.default_image})` : null }}
          />
        )
      })
    }

    return null
  }

  render(){
    const {
      brand: { colour_primary, colour_accent },
      campaign,
      campaignProposal,
      images,
    } = this.props

    return (
      <header className={styles.root}>
        <div
          className={styles.upperTopBar}
          style={{ backgroundColor: colour_accent ? `#${colour_accent}` : `#${colour_primary}` }}
        />
        <div className={styles.topBar} style={{ backgroundColor: colour_primary ? `#${colour_primary}` : null }}>
          <div className={styles.contentHolder}>{this._renderLogo()}</div>
        </div>
        <div className={styles.header}>
          <div className={styles.skew}>
            <div
              className={styles.coverImage}
              style={{ backgroundImage: `url(${coverImageUrl(campaignProposal, images)})` }}
            />
            {this._renederCustomGradient()}
          </div>

          <div className={styles.contentHolder}>
            <div className={styles.details}>
              <h4 className={styles.address}>{campaign.address}</h4>
              <h5 className={styles.suburb}>{campaign.suburb_name}</h5>
            </div>

            <div className={styles.icons}>
              {campaign.bedrooms && <span className={styles.icon}>{campaign.bedrooms} Bed</span>}
              {campaign.bathrooms && <span className={styles.icon}>{campaign.bathrooms} Bath</span>}
              {campaign.carparks && <span className={styles.icon}>{campaign.carparks} Car</span>}
            </div>

            <div className={styles.agents}>{this._renderAgents()}</div>
          </div>
        </div>
      </header>
    )
  }
}

Header.propTypes = {
  agents: PropTypes.object.isRequired,
  brand: PropTypes.object.isRequired,
  campaign: PropTypes.object.isRequired,
  campaignProposal: PropTypes.object.isRequired,
  images: PropTypes.object.isRequired,
}

export default Header
